





import { Component, InjectReactive, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const I18nModule = namespace('i18n');

@Component
export default class NewTranslation extends Vue {
  @I18nModule.Getter
  private readonly translations!: { [path: string]: string };

  @Prop(String)
  public readonly path!: string;

  @Prop(Object)
  public readonly params!: { [k: string]: any };

  @InjectReactive('translate')
  public readonly translate!: (path: string, args: { [key: string]: string }) => string;

  public get message(): string {
    return this.translate(this.path, this.params);
  }
}
